import { Component } from "react";
export default class ServiceContainer extends Component {
    constructor(props) {
        super(props);
        this.callServiceMethod = () => {
            // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
            Promise.resolve(this.props.serviceMethod(...this.props.serviceMethodArgs))
                .then((data) => {
                this.setState({ isLoading: false, data });
            })
                .catch((error) => this.setState({ hasError: true, isLoading: false, error }));
        };
        this.state = {
            data: null,
            isLoading: true,
            hasError: false,
            error: null,
        };
    }
    componentDidMount() {
        this.callServiceMethod();
    }
    componentDidUpdate(prevProps) {
        // Check to see if the args to the service method have changed,
        // and if they have, call the service method again.
        if (prevProps.serviceMethodArgs.length !==
            this.props.serviceMethodArgs.length ||
            !prevProps.serviceMethodArgs.every((elm, index) => elm === this.props.serviceMethodArgs[index])) {
            this.callServiceMethod();
        }
    }
    render() {
        return this.props.children(this.state.data, this.state.isLoading, this.state.hasError, this.state.error);
    }
}
